<template>
	<div>
		<!--编辑 -->
		<el-dialog :title="isEdit?'编辑培训分类':'新增培训分类'" :visible.sync="dialog" @close="unShowClick()" width="30%">
			<el-form ref="addBody" :rules="rules" :model="addBody">
				<el-form-item label="分类名称" prop="name" :label-width="formLabelWidth">
					<el-input v-model="addBody.name" placeholder="请输入分类名称"></el-input>
				</el-form-item>
				<el-form-item label="权重" prop="weight" :label-width="formLabelWidth">
					<el-input v-model="addBody.weight" type='number' placeholder="请输入权重"></el-input>
					<div style="color: #999;">权重数字越大排序越靠前</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="unShowClick()">取 消</el-button>
				<el-button type="primary" @click="updateTrainCate('addBody')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		addTrainCate,
		updateTrainCate,
		getTrainCateDetail
	} from '@/api/train'
	import ImageUpload from "@/components/ImageUpload"
	// import { getAuthListDetail, identityOf, editAuthUser } from '@/api/auth'

	export default {
		props: {
			uuid: {
				type: Object,
				default: {},
			},
			value: {
				type: Boolean,
				default: false,
			},
			dialogProp: {
				type: Boolean,
				default: false,
			},
		},
		components: {
			ImageUpload
		},
		data() {
			return {
				activeName: 'zh',
				readid: '',
				dialog: false,
				identTable: [],
				formLabelWidth: '120px',
				isAddAdmin: true,
				addBody: {
					name: '',
					weight: "",
					uuid: ''
				},
				images: [],
				roleUuid: "",
				rules: {
					name: [{
						required: true,
						message: '请输入分类名称',
						trigger: 'blur'
					}, {
							min: 1,
							max: 30,
							message: '最大30个字符',
							trigger: 'blur'
						} ],
					weight: [{
						required: true,
						message: '请输入权重',
						trigger: 'blur'
					},  {
						// 匹配大于0的数字（包括整数和小数）
						pattern: /^(0*[1-9]\d*(\.\d+)?|0+\.\d*[1-9]\d*)$/,
						message: '必须输入大于0的数字',
						trigger: ['blur', 'change']
					}],
				},
				weightList: [],
				weight: '',
				isEdit: false,
				lmList: [{
						id: 1,
						name: '用户'
					},
					{
						id: 2,
						name: '管理员'
					},
				]
			}
		},
		mounted() {},
		methods: {
			validatePassword(password) {
				const lengthValid = password.length >= 8;
				const hasUpperCase = /[A-Z]/.test(password);
				const hasLowerCase = /[a-z]/.test(password);
				const hasNumber = /\d/.test(password);
				const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
				const criteriaMet = [hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar].filter(Boolean).length >= 2;
				return lengthValid && criteriaMet;
			},
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
				this.addBody.roleUuid = item;
			},
			updateTrainCate(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.isEdit) {
							this.network().updateTrainCate()
						} else {
							this.network().addTrainCate()
						}
					} else {
						return false;
					}
					return false
				});
			},
			unShowClick() {
				this.$emit('input', false)
			},
			network() {
				return {
					addTrainCate: async () => {
						const {
							status,
							data
						} = await addTrainCate({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('新增成功')
					},
					updateTrainCate: async () => {
						const {
							status
						} = await updateTrainCate({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('修改成功')
					},
					getTrainCateDetail: async (uuid) => {
						const {
							data,
							status
						} = await getTrainCateDetail({
							uuid: uuid
						})
						if (status !== 200) return
						this.addBody = data.result
					},
				}
			},
		},

		watch: {
			uuid(val) {
				this.images = []
				if (val.uuid) {
					this.isEdit = true;
					this.network().getTrainCateDetail(val.uuid)
				} else {
					this.isEdit = false;
					this.addBody.name = ''
					this.addBody.weight = ''
					this.addBody.uuid = ''
				}
			},
			value(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.dialog = newVal

					this.network().GoodsWeight()
				}
			},
			dialogProp(old) {
				this.dialog = old;
			},
		},
	};
</script>

<style scoped>
</style>